'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var streams = exports.streams = typeof streamData !== 'undefined' ? streamData : {};

var set = exports.set = function set(key, stream) {
  if (!streams[key]) {
    streams[key] = stream;
  }
};

var markLoaded = exports.markLoaded = function markLoaded(key) {
  if (streams[key]) {
    streams[key].initialLoad = true;
  }
};

var setAttribute = exports.setAttribute = function setAttribute(key, attribute, value) {
  if (streams[key]) {
    streams[key][attribute] = value;
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/bastetjs/lib/utils/streamCache.js
// module id = 180
// module chunks = 0